/**
 * stroke-app.js — интерфейс /stroke-test. Логика и цифры в stroke-engine.js.
 *
 * Этот экран человек открывает одной рукой, второй придерживая падающего
 * родственника. Отсюда решения интерфейса:
 *
 *  1. ВЫЗОВ — ПЕРВОЕ, ЧТО ВИДНО, И НЕ ПРИКЛЕЕН. Ссылка tel: стоит сразу под
 *     интро (шов afterIntro), до инструкции; прежняя липкая плашка съедала
 *     экран на каждом шаге и нарушала решение Фарида против sticky.
 *  2. НОМЕР — ПО СТРАНЕ, ГДЕ ЧЕЛОВЕК, А НЕ ПО ЯЗЫКУ СТРАНИЦЫ. До 2026-09-13
 *     англоязычный посетитель в Великобритании, Индии или ОАЭ видел 911. Страна
 *     берётся из GeoIP (meta geo-country), выбор можно поменять, и он
 *     запоминается.
 *  3. КАЖДЫЙ ШАГ МОЖНО ПРОПУСТИТЬ. Пропущенный шаг уходит в «не проверено» и
 *     НЕ засчитывается как «нормально».
 *  4. ПЕРВЫМИ ИДУТ РАВНОВЕСИЕ И ЗРЕНИЕ — их пропускает схема FAST.
 *  5. ВРЕМЯ СПРАШИВАЕТСЯ ДО ВСЕГО и дальше идёт живыми часами в рейке.
 *  6. РЕЗУЛЬТАТ ЗАКАНЧИВАЕТСЯ ДЕЙСТВИЯМИ: экран «показать бригаде» крупным
 *     шрифтом, что сказать диспетчеру, что делать пока едет скорая, чего нельзя.
 *
 * ⛔ Прокрутки страницы нет нигде: прыжок под пальцем в панике — худшее, что
 * можно сделать с интерфейсом.
 */
(function () {
'use strict';

var BOOT = window.__STROKE || {};
var T = BOOT.T || {};
var CFG = BOOT.cfg || {};
var SLUG = 'stroke-test';
var E = null;

function t(k, r) {
    var s = T[k];
    if (s == null) return k;
    /* По ГРАНИЦЕ имени: `:n` не должен съедать голову `:need`. */
    if (r) Object.keys(r).sort(function (a, b) { return b.length - a.length; }).forEach(function (n) {
        s = s.replace(new RegExp(':' + n + '(?![A-Za-z0-9_])', 'g'), function () { return String(r[n]); });
    });
    return s;
}
function $(id) { return document.getElementById(id); }
function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
}
function funnel(ev, d) { try { if (window.__aeFunnel) window.__aeFunnel(ev, d || {}); } catch (_) { } }

var EMPTY_ANSWERS = function () {
    return { balance: null, eyes: null, face: null, arms: null, speech: null,
             thunderclap: null, numbness: null, confusion: null };
};

var STATE = {
    step: 0,
    lastWellTs: null,
    lastWellKind: null,
    answers: EMPTY_ANSWERS(),
    visited: {},
    arm: { left: null, right: null },
    country: null
};

/* Порядок шагов. Balance и Eyes впереди намеренно — см. шапку. */
var STEPS = ['time', 'balance', 'eyes', 'face', 'arms', 'speech', 'extra', 'result'];
var SIGN_OF_STEP = { balance: 'balance', eyes: 'eyes', face: 'face', arms: 'arms', speech: 'speech' };

/* ── проверка переживает перезагрузку ─────────────────────────────────────
 * Кнопка вызова — tel:-ссылка: человек уходит в звонок, телефон под нехваткой
 * памяти выгружает вкладку. Пройденные шаги и время «последний раз был
 * нормальным» теряться не должны. Живёт 12 часов: вчерашняя чужая проверка
 * при новом испуге хуже пустого экрана.
 */
var SAVE_TTL_MS = 12 * 60 * 60 * 1000;

function saveState() {
    try {
        if (!window.__toolSettings) return;
        window.__toolSettings.save(SLUG, 'session', {
            at: Date.now(), step: STATE.step, lastWellTs: STATE.lastWellTs, lastWellKind: STATE.lastWellKind,
            answers: STATE.answers, visited: STATE.visited, arm: STATE.arm
        });
    } catch (e) { }
}
function restoreState() {
    try {
        if (!window.__toolSettings) return false;
        var v = window.__toolSettings.load(SLUG, 'session', null);
        if (!v || typeof v !== 'object') return false;
        if (!v.at || Date.now() - v.at > SAVE_TTL_MS) { clearState(); return false; }
        if (!v.lastWellTs && !v.step && !v.lastWellKind) return false;
        STATE.step = Math.min(v.step || 0, STEPS.length - 2);
        STATE.lastWellTs = v.lastWellTs || null;
        STATE.lastWellKind = v.lastWellKind || null;
        if (v.answers) Object.keys(STATE.answers).forEach(function (k) { if (v.answers[k] != null) STATE.answers[k] = v.answers[k]; });
        if (v.visited) STATE.visited = v.visited;
        if (v.arm) STATE.arm = v.arm;
        return true;
    } catch (e) { return false; }
}
function clearState() {
    try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'session', null); } catch (e) { }
}

/* ── страна и номер ───────────────────────────────────────────────────── */

var regionNames = null;
function countryName(cc) {
    if (cc === 'ZZ') return '112';
    try {
        if (!regionNames && window.Intl && Intl.DisplayNames) regionNames = new Intl.DisplayNames([CFG.intlLocale || 'en'], { type: 'region' });
        return regionNames ? regionNames.of(cc) : cc;
    } catch (e) { return cc; }
}

function detectCountry() {
    var saved = null;
    try { saved = window.__toolSettings ? window.__toolSettings.load(SLUG, 'country', null) : null; } catch (e) { }
    if (saved && /^[A-Z]{2}$/.test(saved)) return { cc: saved, how: 'saved' };
    var m = document.querySelector('meta[name="geo-country"]');
    var geo = m && (m.getAttribute('content') || '').toUpperCase();
    if (geo && /^[A-Z]{2}$/.test(geo) && geo !== 'XX' && geo !== 'ZZ' && geo !== 'T1') return { cc: geo, how: 'geo' };
    return { cc: CFG.country || 'US', how: 'locale' };
}

function applyCountry(cc, how) {
    STATE.country = cc;
    var num = E.emergencyFor(cc);
    var a = $('stCall');
    if (a) a.href = 'tel:' + num.primary;
    var n = $('stCallNum');
    if (n) n.textContent = num.primary + (num.alt ? ' · ' + num.alt : '');
    var nm = $('stCcName');
    if (nm) nm.textContent = countryName(cc);
    var btn = $('stCcBtn');
    if (btn) btn.title = how === 'geo' ? t('country_auto') : '';
}

function bindCountry() {
    var btn = $('stCcBtn'), box = $('stCcSel'), sel = $('stCcSelect');
    if (!btn || !box || !sel) return;
    var codes = Object.keys(E.EMERGENCY);
    if (codes.indexOf(STATE.country) < 0) codes.push(STATE.country);
    codes.map(function (cc) { return { cc: cc, name: countryName(cc) }; })
        .sort(function (a, b) { return a.name.localeCompare(b.name, CFG.intlLocale || 'en'); })
        .forEach(function (o) {
            var op = el('option', null, o.name + ' — ' + E.emergencyFor(o.cc).primary);
            op.value = o.cc;
            sel.appendChild(op);
        });
    var other = el('option', null, '112 — ' + t('country_pick'));
    other.value = 'ZZ';
    sel.appendChild(other);
    sel.value = STATE.country;
    btn.addEventListener('click', function () {
        box.hidden = !box.hidden;
        btn.setAttribute('aria-expanded', box.hidden ? 'false' : 'true');
        if (!box.hidden) sel.focus();
    });
    sel.addEventListener('change', function () {
        applyCountry(sel.value, 'manual');
        try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'country', sel.value); } catch (e) { }
        funnel('country_changed', { cc: sel.value });
        box.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
    });
    $('stCall').addEventListener('click', function () {
        funnel('emergency_call_tapped', { country: STATE.country, step: STEPS[STATE.step] });
    });
}

/* ── рейка: путь и часы ───────────────────────────────────────────────── */

function stepStatus(id) {
    if (id === 'time') return STATE.lastWellKind ? 'ok' : null;
    if (id === 'extra') {
        var any = E.EXTRA.some(function (x) { return STATE.answers[x] === true; });
        return any ? 'pos' : (STATE.visited.extra ? 'ok' : null);
    }
    var sign = SIGN_OF_STEP[id];
    if (!sign || !STATE.visited[id]) return null;
    var v = STATE.answers[sign];
    return v === true ? 'pos' : v === false ? 'ok' : 'skip';
}

function renderRail() {
    var cur = STEPS[STATE.step];
    document.querySelectorAll('#stSteps .st-si').forEach(function (b) {
        var i = +b.getAttribute('data-step');
        var id = STEPS[i];
        var st = stepStatus(id);
        b.className = 'st-si' + (id === cur ? ' cur' : '') + (st ? ' ' + st : '');
        if (id === cur) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        var s = b.querySelector('.st-si-s');
        s.textContent = id === 'time' && st
            ? (STATE.lastWellTs ? (STATE.lastWellKind === 'h4' ? '≥ 4:00' : fmtTime(STATE.lastWellTs)) : '?')
            : st === 'pos' ? t('rail_status_pos') : st === 'ok' ? t('rail_status_ok') : st === 'skip' ? t('rail_status_skip') : '';
        var d = b.querySelector('.st-si-d');
        d.textContent = st === 'pos' ? '!' : st === 'ok' ? '✓' : st === 'skip' ? '–' : String(i + 1);
    });
    renderClock();
}

function renderClock() {
    var box = $('stClock');
    if (!box) return;
    if (!STATE.lastWellKind) { box.hidden = true; return; }
    box.hidden = false;
    var v = $('stClockV'), s = $('stClockS');
    if (!STATE.lastWellTs) { v.textContent = '—'; s.textContent = t('clock_unknown'); return; }
    var min = Math.max(0, Math.round((Date.now() - STATE.lastWellTs) / 60000));
    var h = Math.floor(min / 60), m = min % 60;
    v.textContent = (STATE.lastWellKind === 'h4' ? '≥ ' : '') + h + ':' + (m < 10 ? '0' : '') + m;
    s.textContent = STATE.lastWellKind === 'h4' ? t('clock_atleast') : t('clock_s', { time: fmtTime(STATE.lastWellTs) });
}

/* ── каркас шага ──────────────────────────────────────────────────────── */

function progress() {
    var p = el('div', 'st-prog');
    p.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < STEPS.length - 1; i++) {
        var st = stepStatus(STEPS[i]);
        p.appendChild(el('i', i === STATE.step ? 'cur' : st === 'pos' ? 'pos' : st ? 'done' : ''));
    }
    return p;
}

function stepCard(id, opts) {
    opts = opts || {};
    var c = el('section', 'tc-panel st-card');
    c.appendChild(progress());
    var eb = el('div', 'st-eyebrow');
    eb.appendChild(el('p', 'tc-eyebrow', t('step_of', { n: STATE.step + 1, all: STEPS.length - 1 })));
    if (opts.tag) eb.appendChild(el('span', 'st-tag' + (opts.missed ? ' missed' : ''), opts.tag));
    var title = t(id + '_title'), q = t(id + '_q');
    if (window.speechSynthesis && window.SpeechSynthesisUtterance) {
        var say = el('button', 'st-say');
        say.type = 'button';
        say.innerHTML = '<span aria-hidden="true">🔊</span>';
        say.appendChild(el('span', null, t('say_aloud')));
        say.addEventListener('click', function () { speak(title + '. ' + q); });
        eb.appendChild(say);
    }
    c.appendChild(eb);
    var h = el('h3', 'st-h', title);
    h.tabIndex = -1;
    c.appendChild(h);
    c.appendChild(el('p', 'st-q', q));
    if (T[id + '_how']) c.appendChild(el('p', 'st-how', t(id + '_how')));
    return c;
}

function speak(text) {
    try {
        var synth = window.speechSynthesis;
        synth.cancel();
        var u = new SpeechSynthesisUtterance(text);
        u.lang = CFG.intlLocale || 'en';
        u.rate = 0.95;
        synth.speak(u);
        funnel('read_aloud', { step: STEPS[STATE.step] });
    } catch (e) { }
}

function footer(c, withSkip, id) {
    var f = el('div', 'st-foot');
    if (STATE.step > 0) {
        var back = el('button', 'st-link', t('back'));
        back.type = 'button';
        back.addEventListener('click', function () { go(STATE.step - 1); });
        f.appendChild(back);
    } else f.appendChild(el('span'));
    if (withSkip) {
        var skip = el('button', 'st-link', t('cant_check'));
        skip.type = 'button';
        skip.addEventListener('click', function () { STATE.answers[id] = null; STATE.visited[STEPS[STATE.step]] = 1; next(); });
        f.appendChild(skip);
    } else if (STATE.step > 0) {
        var res = el('button', 'st-link', t('to_result'));
        res.type = 'button';
        res.addEventListener('click', function () { go(STEPS.length - 1); });
        f.appendChild(res);
    }
    c.appendChild(f);
}

function yesNo(c, id) {
    var w = el('div', 'st-yn');
    w.setAttribute('data-answer', ''); // one gesture = one answer (timbrica-core.js)
    var bad = el('button', 'st-yn-b bad' + (STATE.answers[id] === true ? ' picked' : ''), t('yes_abnormal'));
    bad.type = 'button';
    bad.addEventListener('click', function () { STATE.answers[id] = true; STATE.visited[STEPS[STATE.step]] = 1; next(); });
    var ok = el('button', 'st-yn-b ok' + (STATE.answers[id] === false ? ' picked' : ''), t('no_normal'));
    ok.type = 'button';
    ok.addEventListener('click', function () { STATE.answers[id] = false; STATE.visited[STEPS[STATE.step]] = 1; next(); });
    w.appendChild(bad);
    w.appendChild(ok);
    c.appendChild(w);
    footer(c, true, id);
}

/* ── шаг «время» ──────────────────────────────────────────────────────── */

var QUICK = [
    { id: 'just_now', min: 0 }, { id: 'min15', min: 15 }, { id: 'min30', min: 30 },
    { id: 'h1', min: 60 }, { id: 'h2', min: 120 }, { id: 'h4', min: 240 },
    { id: 'woke', min: null }, { id: 'unknown', min: null }
];

function timeStep() {
    var c = stepCard('time');
    var grid = el('div', 'st-quick');
    grid.setAttribute('data-answer', '');
    var woke = el('div', 'st-woke');
    woke.hidden = true;
    QUICK.forEach(function (q) {
        var b = el('button', 'st-quick-b', t('when_' + q.id));
        b.type = 'button';
        b.addEventListener('click', function () {
            if (q.id === 'woke') {
                /* «Проснулся таким» — не «время неизвестно»: точка отсчёта —
                   когда его видели нормальным вечером. Спрашиваем её. */
                woke.hidden = false;
                var inp = woke.querySelector('input');
                if (inp) inp.focus();
                return;
            }
            STATE.lastWellKind = q.id;
            STATE.lastWellTs = q.min == null ? null : Date.now() - q.min * 60000;
            STATE.visited.time = 1;
            next();
        });
        grid.appendChild(b);
    });
    c.appendChild(grid);

    woke.appendChild(el('p', null, t('woke_q')));
    var wrow = el('div', 'st-exact');
    var winp = el('input');
    winp.type = 'time';
    winp.setAttribute('aria-label', t('woke_q'));
    winp.addEventListener('change', function () { setExact(winp.value, 'woke'); });
    wrow.appendChild(winp);
    var wun = el('button', 'tc-btn ghost sm', t('woke_unknown'));
    wun.type = 'button';
    wun.addEventListener('click', function () { STATE.lastWellKind = 'woke'; STATE.lastWellTs = null; STATE.visited.time = 1; next(); });
    wrow.appendChild(wun);
    woke.appendChild(wrow);
    c.appendChild(woke);

    var exact = el('div', 'st-exact');
    var lab = el('label', 'st-exact-l', t('when_exact'));
    var inp = el('input');
    inp.type = 'time';
    inp.id = 'stExact';
    lab.htmlFor = 'stExact';
    inp.addEventListener('change', function () { setExact(inp.value, 'exact'); });
    exact.appendChild(lab);
    exact.appendChild(inp);
    c.appendChild(exact);
    c.appendChild(el('p', 'tc-note', t('time_why')));
    footer(c, false);
    return c;
}

function setExact(v, kind) {
    if (!/^\d{2}:\d{2}$/.test(v)) return;
    var d = new Date();
    d.setHours(+v.slice(0, 2), +v.slice(3, 5), 0, 0);
    if (d.getTime() > Date.now()) d.setDate(d.getDate() - 1);
    STATE.lastWellTs = d.getTime();
    STATE.lastWellKind = kind;
    STATE.visited.time = 1;
    next();
}

/* ── шаг «лицо»: зеркальная склейка ───────────────────────────────────── */

var cam = null;
function faceStep() {
    var c = stepCard('face', { tag: t('tag_core') });

    var stage = el('div', 'st-face');
    var video = document.createElement('video');
    video.className = 'st-video';
    video.playsInline = true;
    video.muted = true;
    video.setAttribute('playsinline', '');
    stage.appendChild(video);
    stage.appendChild(el('div', 'st-face-guide'));
    var err = el('p', 'st-cam-err');
    stage.appendChild(err);
    c.appendChild(stage);

    var shot = el('div', 'st-mirrors');
    c.appendChild(shot);
    var how = el('p', 'tc-note');
    how.hidden = true;
    c.appendChild(how);

    var snap = el('button', 'tc-btn', t('face_snap'));
    snap.type = 'button';
    snap.disabled = true;
    snap.addEventListener('click', function () { capture(video, shot, how); });
    var row = el('div', 'tc-actions');
    row.appendChild(snap);
    c.appendChild(row);

    yesNo(c, 'face');

    function fail(msg) {
        err.textContent = msg;
        stage.classList.add('failed');
        snap.remove();
    }
    if (window.CameraManager) {
        cam = new window.CameraManager({ slug: SLUG, locale: CFG.locale });
        cam.start({ facingMode: 'user', width: 960, height: 720 }).then(function (stream) {
            video.srcObject = stream;
            video.play().catch(function () { });
            snap.disabled = false;
            setTimeout(function () { if (!video.videoWidth && stage.isConnected) fail(t('cam_no_frames')); }, 6000);
        }).catch(function (e2) {
            var code = (e2 && e2.code) || (window.CameraManager.classify ? window.CameraManager.classify(e2) : 'generic');
            fail((cam && cam.getErrorMessage) ? cam.getErrorMessage(code) : t('cam_generic'));
        });
    } else fail(t('cam_generic'));
    return c;
}

/**
 * Зеркальная склейка: половина лица + её отражение, для каждой половины.
 * ⚠️ Автоматического вердикта здесь НЕТ, и это осознанно: без модели лица
 * опущение угла рта меряется только яркостью, а она зависит от освещения
 * сильнее, чем от паралича. И у любого здорового лица половины немного
 * разные — это сказано рядом с картинкой, чтобы естественная асимметрия не
 * читалась как признак.
 */
function capture(video, host, how) {
    if (!video.videoWidth) return;
    var w = video.videoWidth, h = video.videoHeight;
    // ONE frame of the camera for both halves (an interrupted camera has none this
    // instant — say so instead of leaving the step without pictures)
    var still = document.createElement('canvas');
    still.width = w; still.height = h;
    if (!window.__drawCameraFrame(still.getContext('2d'), video, 0, 0)) {
        if (window.__toast) window.__toast(window.__cameraNoFrame(), 'warning');
        return;
    }
    var half = Math.floor(w / 2);
    host.textContent = '';
    [1, 2].forEach(function (n) {
        var cv = document.createElement('canvas');
        cv.className = 'st-mirror';
        cv.width = half * 2;
        cv.height = h;
        var g = cv.getContext('2d');
        var sx = n === 1 ? 0 : half;
        g.drawImage(still, sx, 0, half, h, 0, 0, half, h);
        g.save();
        g.translate(half * 2, 0);
        g.scale(-1, 1);
        g.drawImage(still, sx, 0, half, h, 0, 0, half, h);
        g.restore();
        var box = el('div');
        box.appendChild(cv);
        box.appendChild(el('span', 'st-mirror-l', t('mirror_' + n)));
        host.appendChild(box);
    });
    how.textContent = t('mirror_how');
    how.hidden = false;
    funnel('face_captured', {});
}

/* ── шаг «руки» ───────────────────────────────────────────────────────── */

function armsStep() {
    var c = stepCard('arms', { tag: t('tag_core') });
    var grid = el('div', 'st-arm-grid');
    var verdict = el('p', 'st-arm-verdict');
    ['left', 'right'].forEach(function (side) {
        var box = el('div', 'st-arm-box');
        box.appendChild(el('b', null, t('arm_' + side)));
        var val = el('div', 'st-arm-val');
        val.id = 'stArmV_' + side;
        box.appendChild(val);
        var b = el('button', 'tc-btn ghost sm', t('arm_start'));
        b.type = 'button';
        b.addEventListener('click', function () { measureArm(side, b, val, verdict); });
        box.appendChild(b);
        grid.appendChild(box);
    });
    c.appendChild(grid);
    c.appendChild(verdict);
    c.appendChild(el('p', 'tc-note', t('arm_note')));
    renderArm(verdict);
    yesNo(c, 'arms');
    return c;
}

function measureArm(side, btn, val, verdictEl) {
    var samples = [];
    var DURATION = 10000;
    var start;

    function begin() {
        start = Date.now();
        btn.disabled = true;
        val.className = 'st-arm-val';
        var onMotion = function (e) {
            var a = e.accelerationIncludingGravity;
            if (!a || a.x == null) return;
            samples.push({ t: Date.now(), x: a.x, y: a.y, z: a.z });
        };
        window.addEventListener('devicemotion', onMotion);
        var iv = setInterval(function () {
            var left = Math.ceil((DURATION - (Date.now() - start)) / 1000);
            val.textContent = String(Math.max(0, left));
            if (left <= 0) {
                clearInterval(iv);
                window.removeEventListener('devicemotion', onMotion);
                btn.disabled = false;
                STATE.arm[side] = E.armDrift(samples);
                if (navigator.vibrate) { try { navigator.vibrate(120); } catch (_) { } }
                renderArm(verdictEl);
                saveState();
            }
        }, 200);
    }

    function noSensor() {
        val.className = 'st-arm-val warn';
        val.textContent = t('arm_no_sensor');
    }
    if (typeof DeviceMotionEvent === 'undefined') { noSensor(); return; }
    if (typeof DeviceMotionEvent.requestPermission === 'function') {
        DeviceMotionEvent.requestPermission().then(function (res) {
            if (res === 'granted') begin(); else noSensor();
        }).catch(noSensor);
    } else begin();
}

function renderArm(verdictEl) {
    ['left', 'right'].forEach(function (side) {
        var v = $('stArmV_' + side);
        if (!v) return;
        var r = STATE.arm[side];
        if (!r) { v.className = 'st-arm-val'; v.textContent = '—'; }
        else if (!r.valid) { v.className = 'st-arm-val warn'; v.textContent = t('arm_invalid_' + r.reason); }
        else { v.className = 'st-arm-val'; v.textContent = t('arm_drift', { deg: r.driftDeg }); }
    });
    var vd = E.armVerdict(STATE.arm.left, STATE.arm.right);
    verdictEl.className = 'st-arm-verdict' + (vd.positive ? ' bad' : '');
    verdictEl.textContent = vd.positive === true
        ? (vd.dropped ? t('arm_dropped') : t('arm_asym', { deg: vd.asymmetryDeg, side: t('arm_' + vd.weaker) }))
        : vd.positive === false ? t('arm_symmetric') : '';
    if (vd.positive != null) STATE.answers.arms = vd.positive;
}

/* ── шаг «речь» ───────────────────────────────────────────────────────── */

var rec = null, recChunks = [], recUrl = null;
function speechStep() {
    var c = stepCard('speech', { tag: t('tag_core') });
    c.appendChild(el('p', 'st-phrase', t('speech_phrase')));
    var host = el('div', 'st-rec');
    c.appendChild(host);
    var b = el('button', 'tc-btn', t('speech_record'));
    b.type = 'button';
    b.addEventListener('click', function () { recordSpeech(b, host); });
    var row = el('div', 'tc-actions');
    row.appendChild(b);
    c.appendChild(row);
    yesNo(c, 'speech');
    return c;
}

/* Микрофон — через общий MicManager: он называет причину отказа. autoHelp:
   false — модальная инструкция поверх проверки в этом сценарии помеха. */
function recordSpeech(btn, host) {
    if (!window.MediaRecorder) { host.textContent = t('speech_no_mic'); return; }
    btn.disabled = true;
    host.textContent = t('speech_recording');
    var mic = window.MicManager ? new window.MicManager({ slug: SLUG, locale: CFG.locale, autoHelp: false }) : null;
    var open = mic ? mic.start()
        : (navigator.mediaDevices ? window.__tmbGum({ audio: true }) : Promise.reject(new Error('no mediaDevices')));
    open.then(function (stream) {
        recChunks = [];
        rec = new MediaRecorder(stream);
        rec.ondataavailable = function (e) { if (e.data.size) recChunks.push(e.data); };
        rec.onstop = function () {
            stream.getTracks().forEach(function (tr) { tr.stop(); });
            if (recUrl) URL.revokeObjectURL(recUrl);
            recUrl = URL.createObjectURL(new Blob(recChunks, { type: rec.mimeType || 'audio/webm' }));
            host.textContent = '';
            var au = document.createElement('audio');
            au.controls = true;
            au.src = recUrl;
            au.className = 'st-audio';
            host.appendChild(au);
            host.appendChild(el('p', 'tc-note', t('speech_listen')));
            btn.disabled = false;
            btn.textContent = t('speech_again');
        };
        rec.start();
        setTimeout(function () { if (rec && rec.state === 'recording') rec.stop(); }, 6000);
    }).catch(function (err) {
        var msg = null;
        try { if (mic && err && err.code) msg = mic.getErrorMessage(err.code); } catch (e) { }
        host.textContent = msg || t('speech_no_mic');
        btn.disabled = false;
    });
}

/* ── дополнительные симптомы ──────────────────────────────────────────── */

function extraStep() {
    var c = stepCard('extra');
    var list = el('div', 'st-extra');
    E.EXTRA.forEach(function (id) {
        var b = el('button', 'st-extra-b' + (STATE.answers[id] ? ' on' : ''));
        b.type = 'button';
        var box = el('i', null, STATE.answers[id] ? '✓' : '');
        box.setAttribute('aria-hidden', 'true');
        b.appendChild(box);
        b.appendChild(el('span', null, t('extra_' + id)));
        b.setAttribute('aria-pressed', STATE.answers[id] ? 'true' : 'false');
        b.addEventListener('click', function () {
            STATE.answers[id] = !STATE.answers[id];
            b.classList.toggle('on', !!STATE.answers[id]);
            box.textContent = STATE.answers[id] ? '✓' : '';
            b.setAttribute('aria-pressed', STATE.answers[id] ? 'true' : 'false');
            renderRail();
        });
        list.appendChild(b);
    });
    c.appendChild(list);
    var go2 = el('button', 'tc-btn', t('extra_done'));
    go2.type = 'button';
    go2.className = 'tc-btn st-extra-go';
    go2.addEventListener('click', function () { STATE.visited.extra = 1; next(); });
    c.appendChild(go2);
    footer(c, false);
    return c;
}

/* ── результат ────────────────────────────────────────────────────────── */

function assessNow() {
    return E.assess(STATE.answers, {
        lastWellTs: STATE.lastWellTs,
        atLeast: STATE.lastWellKind === 'h4',
        sudden: STATE.lastWellKind === 'just_now' || STATE.lastWellKind === 'min15'
    });
}

function resultStep() {
    var R = assessNow();
    var wrap = el('div', 'st-res');
    var neg = R.verdict === 'negative';

    var v = el('section', 'tc-panel st-v' + (neg ? ' neg' : ''));
    v.appendChild(el('h3', 'st-v-t', t('verdict_' + R.verdict)));
    v.appendChild(el('p', 'st-v-d', t('verdict_' + R.verdict + '_d')));
    if (R.positives.length) {
        var ul = el('ul', 'st-found');
        R.positives.forEach(function (id) { ul.appendChild(el('li', null, t('found_' + id))); });
        v.appendChild(ul);
    }
    if (R.posteriorOnly) v.appendChild(el('p', 'tc-msg', t('posterior_note')));

    var act = el('div', 'st-v-actions');
    var disp = el('button', 'tc-btn', t('disp_btn'));
    disp.type = 'button';
    disp.addEventListener('click', function () { openDispatch(R); });
    act.appendChild(disp);
    var sh = el('button', 'tc-btn ghost', t('share_btn'));
    sh.type = 'button';
    sh.addEventListener('click', function () { share(R); });
    act.appendChild(sh);
    var pr = el('button', 'tc-btn ghost', t('print_btn'));
    pr.type = 'button';
    pr.addEventListener('click', function () { funnel('print', {}); window.print(); });
    act.appendChild(pr);
    v.appendChild(act);
    wrap.appendChild(v);

    /* Время — вторая половина результата. */
    var tm = el('section', 'tc-panel');
    var th = el('div', 'tc-head');
    th.appendChild(el('h3', 'tc-title', t('result_time_title')));
    tm.appendChild(th);
    if (R.time.unknown) {
        tm.appendChild(el('p', 'tc-msg', t('time_unknown')));
    } else {
        tm.appendChild(el('p', 'st-stamp', t('time_elapsed', { h: Math.floor(R.time.elapsedMin / 60), m: R.time.elapsedMin % 60 })
            + (STATE.lastWellKind === 'h4' ? '' : ' · ' + t('clock_s', { time: fmtTime(STATE.lastWellTs) }))));
        tm.appendChild(timeline(R.time));
        var wl = el('ul', 'st-wins');
        R.time.windows.forEach(function (w) {
            var li = el('li', 'st-win' + (w.open ? '' : ' closed'));
            li.appendChild(el('span', null, t('win_' + w.id)));
            li.appendChild(el('b', null, w.open
                ? t(w.upTo ? 'win_left_upto' : 'win_left', { h: Math.floor(w.leftMin / 60), m: w.leftMin % 60 })
                : t('win_closed')));
            wl.appendChild(li);
        });
        tm.appendChild(wl);
    }
    tm.appendChild(el('p', 'tc-note', t('windows_caveat')));
    wrap.appendChild(tm);

    var cols = el('div', 'st-cols');
    cols.appendChild(listPanel(t('script_title'), E.dispatchScript({}).order.map(function (k) { return t('script_' + k); }), true,
        STATE.lastWellTs && STATE.lastWellKind !== 'h4' ? t('script_stamp', { time: fmtTime(STATE.lastWellTs) }) : null));
    cols.appendChild(listPanel(t('waiting_title'), (R.waiting || []).map(function (k) { return t('wait_' + k); }), false));
    cols.appendChild(listPanel(t('donts_title'), R.donts.map(function (d) { return t('dont_' + d); }), false));
    wrap.appendChild(cols);

    var endRow = el('div', 'st-foot');
    var back = el('button', 'st-link', t('back'));
    back.type = 'button';
    back.addEventListener('click', function () { go(STEPS.length - 2); });
    endRow.appendChild(back);
    var again = el('button', 'st-link', t('restart'));
    again.type = 'button';
    again.addEventListener('click', function () {
        STATE.answers = EMPTY_ANSWERS();
        STATE.arm = { left: null, right: null };
        STATE.visited = {};
        STATE.lastWellTs = null; STATE.lastWellKind = null;
        clearState();
        go(0);
    });
    endRow.appendChild(again);
    wrap.appendChild(endRow);
    wrap.appendChild(el('p', 'tc-disclaimer', t('disclaimer')));

    if (window.__aeToolComplete) {
        window.__aeToolComplete({ verdict: R.verdict, posterior_only: R.posteriorOnly, positives: R.positives.length, country: STATE.country, lkw: STATE.lastWellKind || '' });
    }
    stopCamera();
    releaseWake();
    return wrap;
}

function listPanel(title, items, ordered, stamp) {
    var p = el('section', 'tc-panel');
    var h = el('div', 'tc-head');
    h.appendChild(el('h3', 'tc-title', title));
    p.appendChild(h);
    var l = el(ordered ? 'ol' : 'ul', 'st-list');
    items.forEach(function (s) { l.appendChild(el('li', null, s)); });
    p.appendChild(l);
    if (stamp) p.appendChild(el('p', 'st-stamp', stamp));
    return p;
}

/* Шкала суток: окна 4,5 / 9 / 24 ч и отметка «сейчас». Сегменты
   пропорциональны часам, поэтому метка ставится в процентах от 24 ч. */
function timeline(time) {
    var box = el('div', 'st-tl');
    box.setAttribute('aria-hidden', 'true');
    var bar = el('div', 'st-tl-bar');
    bar.appendChild(el('i'));
    bar.appendChild(el('i'));
    bar.appendChild(el('i'));
    box.appendChild(bar);
    var pct = Math.min(100, (time.elapsedMin / (24 * 60)) * 100);
    var now = el('span', 'st-tl-now', (time.atLeast ? '≥ ' : '') + t('tl_now'));
    now.style.insetInlineStart = Math.max(3, Math.min(97, pct)) + '%';
    box.appendChild(now);
    var ticks = el('div', 'st-tl-ticks');
    var nf;
    try { nf = new Intl.NumberFormat(CFG.intlLocale || 'en'); } catch (e) { nf = { format: String }; }
    [4.5, 9, 24].forEach(function (x) { ticks.appendChild(el('span', null, t('tl_hours', { n: nf.format(x) }))); });
    box.appendChild(ticks);
    return box;
}

/* ── экран «показать бригаде» ─────────────────────────────────────────── */

function signsText(R) {
    return R.positives.length ? R.positives.map(function (id) { return t('found_' + id); }).join(', ') : t('share_none');
}
function whenText() {
    if (!STATE.lastWellTs) return t('time_unknown');
    var min = Math.round((Date.now() - STATE.lastWellTs) / 60000);
    return (STATE.lastWellKind === 'h4' ? '≥ ' : fmtTime(STATE.lastWellTs) + ' · ') + t('time_elapsed', { h: Math.floor(min / 60), m: min % 60 });
}

function openDispatch(R) {
    var d = $('stDisp');
    if (!d) return;
    $('stDispWhen').textContent = whenText();
    $('stDispSigns').textContent = signsText(R);
    funnel('dispatch_screen', {});
    if (typeof d.showModal === 'function') {
        d.showModal();
    } else {
        d.setAttribute('open', '');
    }
}

function share(R) {
    var text = [t('share_head', { verdict: t('verdict_' + R.verdict) }),
        t('share_when') + ' ' + whenText(),
        t('share_signs') + ' ' + signsText(R)].join('\n');
    funnel('share', { verdict: R.verdict });
    if (navigator.share) {
        navigator.share({ text: text }).catch(function (e) { if (!e || e.name !== 'AbortError') copy(text); });
        return;
    }
    copy(text);
}
function copy(text) {
    var done = function () { if (window.__toast) window.__toast(t('share_copied'), 'success'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () { });
}

/* ── экран не гаснет, пока идёт проверка ──────────────────────────────────
   Только через общий window.__wakeLock: своя копия проверяла «держу ли я
   объект», а не «держится ли замок», и после заморозки вкладки экран гас,
   пока интерфейс считал его удержанным (WakeLockPrimitiveTest). */
var waking = false;
function holdWake() {
    if (waking || !window.__wakeLock || document.visibilityState !== 'visible') return;
    waking = true;
    try { window.__wakeLock.request(); } catch (e) { waking = false; }
}
function releaseWake() {
    if (!waking) return;
    waking = false;
    try { if (window.__wakeLock) window.__wakeLock.release(); } catch (e) { }
}

var tfmt = null;
function fmtTime(ts) {
    if (!tfmt) {
        try { tfmt = new Intl.DateTimeFormat(CFG.intlLocale || 'en', { hour: '2-digit', minute: '2-digit' }); }
        catch (e) { tfmt = { format: function (d) { return new Date(d).toTimeString().slice(0, 5); } }; }
    }
    return tfmt.format(new Date(ts));
}

function stopCamera() { if (cam) { try { cam.stop(); } catch (e) { } cam = null; } }

/* ── навигация ────────────────────────────────────────────────────────── */

function next() { go(STATE.step + 1); }

function go(i) {
    STATE.step = Math.max(0, Math.min(STEPS.length - 1, i));
    render(true);
}

function render(moved) {
    var host = $('stApp');
    var id = STEPS[STATE.step];
    if (id !== 'face') stopCamera();
    if (window.speechSynthesis) { try { window.speechSynthesis.cancel(); } catch (_) { } }

    var body;
    switch (id) {
        case 'time':    body = timeStep(); break;
        case 'balance': body = signStep('balance'); break;
        case 'eyes':    body = signStep('eyes'); break;
        case 'face':    body = faceStep(); break;
        case 'arms':    body = armsStep(); break;
        case 'speech':  body = speechStep(); break;
        case 'extra':   body = extraStep(); break;
        default:        body = resultStep(); break;
    }
    host.textContent = '';
    host.appendChild(body);
    renderRail();
    if (moved) {
        /* Фокус — на заголовок шага, без прокрутки страницы: экранный диктор
           читает новый вопрос, а зрячий видит его на том же месте. */
        var h = host.querySelector('.st-h');
        if (h) { try { h.focus({ preventScroll: true }); } catch (_) { } }
    }
    if (STATE.step > 0 && id !== 'result') holdWake();
    if (window.__stage) window.__stage(id);
    if (id === 'result') clearState(); else saveState();
}

function signStep(id) {
    var c = stepCard(id, { tag: t('tag_missed'), missed: true });
    yesNo(c, id);
    return c;
}

function boot() {
    var host = $('stApp');
    if (!host) return;
    E = window.StrokeEngine;
    if (!E) {
        host.textContent = '';
        var c = el('section', 'tc-panel st-card');
        c.appendChild(el('p', 'tc-msg bad', t('load_error')));
        host.appendChild(c);
        return;
    }
    var cc = detectCountry();
    applyCountry(cc.cc, cc.how);
    bindCountry();

    document.querySelectorAll('#stSteps .st-si').forEach(function (b) {
        b.addEventListener('click', function () { go(+b.getAttribute('data-step')); });
    });
    var tr = $('stToRes');
    if (tr) tr.addEventListener('click', function () { go(STEPS.length - 1); });
    var dc = $('stDispClose');
    if (dc) dc.addEventListener('click', function () { var d = $('stDisp'); if (d.close) d.close(); else d.removeAttribute('open'); });

    restoreState();
    render(false);
    setInterval(renderClock, 20000);
}

document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopCamera();
});
window.addEventListener('pagehide', stopCamera);

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

})();
